

import { ExtendedArchive, Extract, } from "../library/CosmeWidgetAPIClient";
import { useContext, useEffect, useState } from "react";
import PageLoading from "../parts/PageLoading";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Divider, Link, Title3, Toolbar, ToolbarButton, ToolbarDivider, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import ExtractTable from "../parts/extract/ExtractTable";

import PreviewPain from "../parts/extract/PreviewPain";
import { CWClientContext } from "../App";
import {
    CheckboxChecked24Filled, CheckboxChecked24Regular,
    Pause24Filled, Pause24Regular,
    DocumentTextExtract24Filled, DocumentTextExtract24Regular,
    ArrowHookUpLeft24Filled, ArrowHookUpLeft24Regular,
    EyeOff24Filled, EyeOff24Regular,
    bundleIcon
} from "@fluentui/react-icons"

const CheckboxChecked = bundleIcon(CheckboxChecked24Filled, CheckboxChecked24Regular,);
const Pause = bundleIcon(Pause24Filled, Pause24Regular,);
const ArrowHookUpLeft = bundleIcon(ArrowHookUpLeft24Filled, ArrowHookUpLeft24Regular,);
const EyeOff = bundleIcon(EyeOff24Filled, EyeOff24Regular,);
const DocumentTextExtract = bundleIcon(DocumentTextExtract24Filled, DocumentTextExtract24Regular,);

const useStyles = makeStyles({
    header: {
        width: "100vw",
        marginTop: "20px",
    },
    leftPain: {
        marginLeft: "1%",
        width: "44%",
    },
    rightPain: {
        marginRight: "1%",
        width: "54%",
    },
    card: {
        ...shorthands.margin("12px"),
        ...shorthands.borderRadius("12px"),
        ...shorthands.borderColor("pink"),
        width: "120px",
        boxShadow: tokens.shadow8,
        maxWidth: "100%",
    },

    container: {
        display: "flex",
        flexWrap: "nowrap",
        ...shorthands.overflow("hidden"),
        marginTop: "8px",
    },
    button: {
        ...shorthands.borderRadius("4px"),
        ...shorthands.margin("3px"),
        ...shorthands.borderStyle("solid"),
        ...shorthands.borderWidth("1px"),
        ...shorthands.borderColor("lightgray"),
    }
});
/**
 * 
 * @returns 
 */
function ExtractDetail() {
    const styles = useStyles();
    const [extracts, setExtracts] = useState<Extract[]>();
    const [archive, setArchive] = useState<ExtendedArchive>();
    // const cwClient: CosmeWidgetAPIClient = new CosmeWidgetAPIClient();
    const location = useLocation();
    const cwClient = useContext(CWClientContext);


    const { archiveId } = useParams();
    if (archiveId === undefined) {
        location.pathname = '/extract/new';
    }
    useEffect(() => {
        (async () => {
            if (archiveId !== undefined) {
                let archiveRes = await cwClient.getArchive(archiveId);
                setArchive(archiveRes);
                let extractRes = await cwClient.getExtracts(archiveId);
                setExtracts(extractRes);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const ingnoreArchive = (url: string, archivePath: string) => {
        (async () => {
            cwClient.ignoreArchive(url, archivePath).then((res) => {
                //行のｃlaｓｓName=ignoreにする
                // itemsの該当のExtractのstatusをignoreにする
                console.log(res);
            });
        })();
    }
    const fixArchive = (url: string, archivePath: string) => {
        (async () => {
            cwClient.fixArchive(url, archivePath).then((res) => {
                //行のｃlaｓｓName=ignoreにする
                // itemsの該当のExtractのstatusをignoreにする
                console.log(res);
            });
        })();
    }
    const pendingArchive = (url: string, archivePath: string) => {
        (async () => {
            cwClient.pendingArchive(url, archivePath).then((res) => {
                //行のｃlaｓｓName=ignoreにする
                // itemsの該当のExtractのstatusをignoreにする
                console.log(res);
            });
        })();
    }
    const navigate = useNavigate();
    const extractsPain = () => {

        if (extracts === undefined || archive === undefined) {
            return (
                <PageLoading
                    message="抽出情報を取得しています"
                />
            )
        } else {
            return (
                <>
                    {/* 全てがMasterと紐づいているか、無視になっている場合Enable */}
                    <Toolbar>
                        <ToolbarButton
                            icon={<CheckboxChecked />}
                            className={styles.button}
                            onClick={() => {
                                fixArchive(archive.archive.url, archive.archive.archivePath);
                                navigate("/extract");
                            }}
                        >
                            完了
                        </ToolbarButton>
                        <ToolbarButton
                            icon={<Pause />}
                            className={styles.button}
                            onClick={() => {
                                pendingArchive(archive.archive.url, archive.archive.archivePath);
                                navigate("/extract");
                            }}
                        >保留</ToolbarButton>
                        <ToolbarButton
                            icon={<EyeOff />}
                            className={styles.button}
                            onClick={() => {
                                ingnoreArchive(archive.archive.url, archive.archive.archivePath);
                                navigate("/extract");
                            }}
                        >無視</ToolbarButton>
                        <ToolbarButton
                            icon={<ArrowHookUpLeft />}
                            className={styles.button}
                            onClick={() => {
                                navigate("/extract");
                            }}
                        >一覧に戻る</ToolbarButton>
                        <ToolbarDivider />
                        <ToolbarButton
                            icon={<DocumentTextExtract />}
                            className={styles.button}
                            onClick={() => {
                                setExtracts(undefined);
                                cwClient.reExtract(archive.archive.id).then((res) => {
                                    setExtracts(res);
                                });
                            }}
                        >再抽出</ToolbarButton>
                    </Toolbar>
                    <ExtractTable
                        extracts={extracts}
                        archive={archive}
                    />


                </>
            )
        }


    }


    if (archive === undefined) {
        return <PageLoading
            message="ページ情報を取得しています"
        />;
    }
    return (
        <>
            <div className={styles.header}>
                <Title3>{archive.archive.pageTitle}</Title3>
                <br />
                <Link href={archive.archive.url} target="_blank">{archive.archive.url}</Link>
            </div>

            <Divider ></Divider>
            <div className={styles.container}>
                <div className={styles.leftPain}>
                    {extractsPain()}
                </div>
                <div className={styles.rightPain}>
                    <PreviewPain
                        archive={archive}
                    />
                </div>
            </div>
            {/* </div> */}
            {/* </div> */}
            {/* </div> */}
        </>
    );
}
export default ExtractDetail;